<template>
<div id="ag-grid-demo">
        <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3 mt-10">
            <div class="filters-container flex flex-wrap items-center justify-start pb-3">
                <v-select
                    style="min-width: 200px"
                    class="mt-3 mr-3"
                    name="company"
                    label="name"
                    placeholder="Actions"
                    v-model="selected"
                    :options="status"
                    @input="getFilteredList"
                />
                <button
                    class="mt-3 ml-3 add_new_button add_new_button-mobile"
                    @click="$router.push({ name: 'company-admin-sms-template-add' })"
                >+ Add New</button>
            </div>
            <div class="flex pagination-header">
                <per-page
                    :currentPerPage="per_page"
                    :pageStart="pageStart"
                    :pageEnd="pageEnd"
                    :total="total"
                    @change-per-page="ChangePerPage($event)"
                />
                <div class="form-group has-search has-search-mobile" v-on:click="onQuickFilterChanged()">
                    <span class="fa fa-search form-control-feedback"></span>
                    <input
                    type="search"
                    v-on:input="onQuickFilterChanged()"
                    id="quickFilter"
                    class="filter_input form-control"
                    >
                </div>
            </div>
        </div>
        <div class="table_container" style="width: 100%; flex: 1 1 auto;">
            <ag-grid-vue
                class="w-100 my-4 ag-grid-table ag-grid-table-responsive ag-theme-material"
                id="myGrid"
                :class="{'noDataTable': !list.length}"
                :suppressColumnVirtualisation="true"
                :components="components"
                :gridOptions="gridOptions"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                @gridReady="GridReady"
                :pagination="true"
                colResizeDefault="shift"
                :suppressPaginationPanel="true"
                :rowData="list"
                :rowSelection="rowSelection"
                :animateRows="true"
                :floatingFilter="isFloatingFilter"
            ></ag-grid-vue>
            <vs-pagination
              v-if="list.length"
            :total="totalPages"
            class="pag"
            :max="maxPageNumbers"
            v-model="Page" />
        </div>
    </div>
</template>
<script>
import TableMixin from '@/mixins/table.js'

// Packages
import vSelect from 'vue-select'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from '../../../views/company-admin/SMSTemplate/cell-renderer/CellRendererActions'
import CellRendererStatus from '../../admin/clients/users/cell-renderer/CellRendererStatus'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { format } from 'date-fns'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'


// Cell Renderer components
export default {
    mixins: [TableMixin],
  components: {
    AgGridVue,
    vSelect,
    CellRendererActions,
    CellRendererStatus,
  },
data (){
      return{
        components: {
            CellRendererActions,
            CellRendererStatus
      },
        status: [
          'all',
          'approved',
          'rejected'
        ],
        selected: 'all',
        columnDefs : [
          {
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
          },
        {
            headerName: 'Template',
            field:'template_name',
            flex:1
        },
        {
            headerName: 'Category',
            field: 'category',
            flex: 2
        },
       {
            headerName: 'POPULARITY',
            field: 'popularity',
            flex:2,
            width: 100,
        },
        {
            headerName: 'Status',
            field: 'status',
            flex:2,
            cellRenderer: (params) => {
                if(params.value=='approved'){
                    return '<span class="badge badge-pill success">'+params.value+'</span>'
                } else if(params.value=="rejected"){
                    return '<span class="badge badge-pill warning-red">'+params.value+'</span>'
                }else{
                  console.log(params.value == null)
                 if(params.value == null) {
                    return  ''
                 }else {
                   return '<span class="badge badge-pill primary">waiting</span>'
                 }
                }
            }
        },
        {
            headerName: 'Action',
            field: 'action',
          width: 120,
            cellRendererFramework: 'CellRendererActions',
        }
]
      }

  },
  beforeMount(){
       this.rowSelection = 'multiple';
      this.gridOptions = {
            rowHeight: 80,
            rowStyle: {
        'border-bottom': '#F8F8F8 10px solid',
        'border-top': '#F8F8F8 10px solid'
    },
        };
  },
    created() {
    this.GetList()
  },
  methods: {
    onGridSizeChanged(params) {
      if (params.clientWidth > 500) {
        this.gridApi.sizeColumnsToFit();
      } else {
        this.columnDefs.forEach(x => {
          x.width = 300;
        });
        this.gridApi.setColumnDefs(this.columnDefs);
      }
    },
    getFilteredList() {
      this.$vs.loading()
      if(this.selected == 'all') {
       this.GetList()
        return false
      }
      this.$store.dispatch('smsTemplate/GetFilterList', this.selected)
      .then((res) => {
        this.list = res.items.map(this.TransformList)
        this.total = res.total
      }).catch(err => {})
        .finally(() => this.$vs.loading.close())
    },
    GetList () {
        this.$vs.loading()
        this.$store.dispatch('smsTemplate/GetList', {
        ...this.filters,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc',
        page: this.page || 0,
        per_page: this.per_page || 20,
      })
      .then(res => {
        this.list = res.items.map(this.TransformList)
        this.total = res.total
      })
      .catch(err => {})
      .finally(() => this.$vs.loading.close())
    },
    TransformList(item) {
      return {
        refreshData: this.GetList,
        template_name: item.template_name,
        created_on: format(new Date(item.created_on), 'yyyy:MM:dd HH:mm:ss'),
        created_by: item.created_by,
        sms_template_uuid: item.sms_template_uuid,
        status: item.status
      }
    },
    onQuickFilterChanged() {
      this.gridApi.setQuickFilter(document.getElementById('quickFilter').value);
    },
  },
}
</script>
<style>
    .container_{
        width: 85%;
        margin:auto;
    }
    .add_new_button{
        width: 100px;
        height: 40px;
        border:1px solid #7367EC;
        color: #7367EC;
        border-radius: 5px;
        background-color: white;
    }
    .add_new_button:hover{
        background-color: #7367EC;
        color: white;
        transition: 0.5s;
    }
    .table_container{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .ag-theme-material .ag-root-wrapper {
        background-color: transparent!important;
    }
    .ag-theme-material .ag-header {
        background-color: transparent!important;
        border-bottom: none!important;
    }
    .ag-theme-material .ag-row {
        background: white;
        border-radius: 10px;
    }
    .filter_input{
        border:1px solid lightgray;
        border-radius:30px;
        margin-left: 15px;
    }
    .badge{
        color: white;
        padding: 3%;
        border-radius: 55px;
    }
    .primary{
        background-color:#7367EC ;
        color: white;
    }
    .success{
        background-color: #1EC775;
        color: white;
    }
    .warning{
        background-color: #FE9E4D;
        color: white;
    }
    .warning-red{
      background-color: red;
      color: white;
    }
    .ag-header-cell-label {
   justify-content: center;
}
.ag-grid-table{
   justify-content: center;
}
.ag-row{
    text-align: center;
}
.filter_input{
  padding: 17px;
  padding-left: 55px;
  width: 300px;
  border: 1px solid #f5f5f5;
  font-size: 13px;
  color: gray;
  background-repeat: no-repeat;
  background-position: left center;
  outline: 0;
}
.has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 15px;
    height: 15px;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: gray;
    margin-left: 35px;
    margin-top: 20px;
}
.ag-cell-value, .ag-group-value {
  overflow: inherit!important;
  text-overflow: unset!important;
}

@media (max-width: 512px) {
  .has-search-mobile {
    width: 100%!important;
    max-width: 50%!important;
  }
  .add_new_button-mobile {
    margin-left: 0!important;
  }
  .filter_input {
    max-width: 100%;
  }
  .ag-grid-table-responsive {
      width: 203%!important;
      overflow-x: scroll!important;
  }
}
@media (max-width: 400px) {
  .has-search-mobile {
    width: 100%!important;
    max-width: 50%!important;
  }
  .add_new_button-mobile {
    margin-left: 0!important;
  }
   .filter_input {
    max-width: 100%;
  }
    .ag-grid-table-responsive {
      width: 200%!important;
      overflow-x: scroll!important;
  }
}
 </style>
